import { TL } from '@/components/design-system'
import { getWrapperClassName } from '@/components/design-system/utils'
import { FormulaireContact } from '@/components/shared/FormulaireContact'
import { Route } from '@/route'
import { graphql, useStaticQuery } from 'gatsby'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next'
import React from 'react'
import packageJson from '../../../package.json'

type Props = Readonly<{
  className: string
}>

export const Footer = (props: Props) => {
  const { t } = useTranslation()
  const annee = new Date().getFullYear()
  const data = useStaticQuery(graphql`
    query {
      images: allImageSharp {
        edges {
          node {
            original {
              src
            }
          }
        }
      }
    }
  `)
  const images = data.images.edges.map(({ node }) => node.original)
  const background = images.find(i => i.src.includes('footer-background'))

  return (
      <footer
          id="contact"
          style={ {
            background: `linear-gradient(90deg, #EFF1FF 50%, rgba(255, 255, 255, 0.50) 100%), url(${ background.src })`,
            backgroundRepeat: 'no-repeat',
            backgroundPositionX: 'right',
            backgroundSize: 'auto'
          } }
          className={ getWrapperClassName(props.className, 'flex gap-10 mt-24 py-10 max-lg:mt-16 max-md:!bg-none max-md:!bg-lightblue wide:!bg-none wide:!bg-lightblue') }>
        <div
            className="flex gap-24 mx-24 w-screen max-w-7xl mx-auto max-xl:mx-24 max-sm:mx-7 max-md:flex-col max-md:gap-16">
          <div className="w-fit max-md:order-2 max-md:self-center">
            <Link to={ Route.ORIGINE }>
              <TL.Logo width={ 142 } height={ 60 } tooltip={ t('marque')! }/>
            </Link>

            <div className="text-lg mt-6">
              <p>{ t('adresse.rue') }</p>
              <p>{ t('adresse.ville') }</p>
              <p>{ t('adresse.pays') }</p>
            </div>

            <div className="flex justify-center gap-6 mt-16 text-digitalblue">
              <a href={ t('reseaux-sociaux.linkedin')! } target="_blank"><TL.Icons.LinkedIn/></a>
              <a href={ t('reseaux-sociaux.youtube')! } target="_blank"><TL.Icons.Youtube/></a>
            </div>

            <p className="text-xs font-thin mt-5">© { annee } { t('marque') } { packageJson.version }</p>
          </div>

          <FormulaireContact className="w-[350px] max-md:order-1 max-md:w-full"/>
        </div>
      </footer>
  )
}

Footer.defaultProps = {
  className: ''
}
